import React from 'react';
import classNames from 'classnames';
import { Box } from '@wix/design-system';
import s from './FeatureRow.scss';
import { FeatureRowCell } from './FeatureRowCell';
import { FeatureRowValue } from './FeatureRowValue';
import { FeatureRowHeader } from './FeatureRowHeader';
import dataHooks from './FeatureRow.datahooks';
export const FeatureRow = ({ children, className, size = 'medium', dataHook }) => {
    return (React.createElement(Box, { dataHook: dataHooks.featureRow, display: "contents" },
        React.createElement(Box, { className: classNames(s.featureRow, className, s[size]), direction: "horizontal", dataHook: dataHook, display: "contents" }, children)));
};
FeatureRow.Cell = FeatureRowCell;
FeatureRow.Value = FeatureRowValue;
FeatureRow.Header = FeatureRowHeader;
//# sourceMappingURL=FeatureRow.js.map